export {FooterMenu} from './lib/footer-menu';